import React, { Component, useState } from 'react';
import { string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import Select from 'react-select';
import * as validators from '../../../util/validators';
import appSettings from '../../../config/settings';
import { availableWorkingHours, roleGroups } from '../../../config/configListing';
import { FormattedMessage, injectIntl, intlShape } from '../../../util/reactIntl';

import {
    Form,
    FieldTextInput,
    H4,
    PrimaryButton,
    FieldSelect,
    SecondaryButton,
    NamedLink,
    IconCard,
} from '../../../components';

import requestformLogo from '../../../assets/images/requestform-logo.png';

import css from './ChatForm.module.css';
import { createResourceLocatorString } from '../../../util/routes';
import { useRouteConfiguration } from '../../../context/routeConfigurationContext';

class ChatFormComponent extends Component {
    constructor(props) {
        super(props);
        this.submittedValues = {};
    }

    render() {
        return (
            <FinalForm
                {...this.props}
                render={fieldRenderProps => {
                    const {
                        handleSubmit,
                        invalid,
                        form,
                        values,
                        intl,
                        name = '',
                        config,
                        showModal,
                        inProgress,
                        currentUserListings,
                        showPortfolio,
                        portfolioId,
                        insufficientTokens,
                        tokensToDeduct,
                        firstConnectionRequest,
                        firstConnectionOnAfterDisable,
                        studentListingExperience = [],
                        history,
                    } = fieldRenderProps;
                    const routeConfiguration = useRouteConfiguration();
                    const [alreadyBooked, setAlreadyBooked] = useState({ booked: false, transactionId: '' })

                    const findRoleGroup = (roleLabel) => {
                        for (const [group, roles] of Object.entries(roleGroups)) {
                            if (roles?.map(r => r.toLowerCase()).includes(roleLabel?.toLowerCase())) {
                                return group;
                            }
                        }
                        return null;
                    };

                    const studentLabels = Array.isArray(studentListingExperience)
                        ? studentListingExperience.map(item => item?.label).filter(Boolean)
                        : [];


                    const boardMember = (studentListingExperience && studentListingExperience.length && Array.isArray(studentListingExperience) && studentListingExperience[0]?.boardMember) || false;

                    const currentUserLabels = Array.isArray(currentUserListings)
                        ? currentUserListings.flatMap(listing =>
                            Array.isArray(listing?.attributes?.publicData?.roles)
                                ? listing.attributes.publicData.roles.map(role => role?.label).filter(Boolean)
                                : []
                        )
                        : [];
                    const matchingLabels = studentLabels?.filter(studentRole => {
                        const studentGroup = findRoleGroup(studentRole);
                        return currentUserLabels?.some(companyRole => {
                            const companyGroup = findRoleGroup(companyRole);
                            return studentGroup && companyGroup && studentGroup === companyGroup;
                        });
                    });


                    function getInitials(name) {
                        return name?.split(' ').map(word => word?.charAt(0)?.toUpperCase())?.join('');
                    }
                    const initials = getInitials(name);

                    const { highestExperience: highestExperiences, parentJobRoles } = config.listing || {};

                    // email
                    const emailLabel = intl.formatMessage({
                        id: 'ChatForm.emailLabel',
                    });
                    const emailPlaceholder = intl.formatMessage({
                        id: 'ChatForm.emailPlaceholder',
                    });
                    const emailRequiredMessage = intl.formatMessage({
                        id: 'ChatForm.emailRequired',
                    });
                    const emailRequired = validators.required(emailRequiredMessage);
                    const emailInvalidMessage = intl.formatMessage({
                        id: 'ChatForm.emailInvalid',
                    });
                    const emailValid = validators.emailFormatValid(emailInvalidMessage);

                    const submitDisabled = invalid;

                    const CustomOption = (props) => {
                        const { data, innerRef, innerProps, selectProps } = props;

                        const handleEyeClick = (e) => {
                            e.stopPropagation();
                            window.open(
                                `${process.env.REACT_APP_MARKETPLACE_ROOT_URL}/l/${data?.label}/${data?.value}/edit/requirements`,
                                '_blank'
                            );
                        };

                        const index = selectProps?.options?.findIndex(
                            (option) => option?.value === data?.value
                        );

                        return (
                            <div>
                                <div
                                    ref={innerRef}
                                    {...innerProps}
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        padding: '9px 16px',
                                        cursor: 'pointer',
                                        borderRadius: '50px',
                                        border: '1px solid #ddd',
                                        borderTop: index === 0 ? 'none' : '1px solid #ddd', // No top border on first item
                                        backgroundColor: '#fff',
                                        marginTop: index > 0 ? '8px' : '0',
                                    }}
                                >
                                    <span>{data?.label}</span>
                                    <p
                                        onClick={handleEyeClick}
                                        style={{ cursor: 'pointer', margin: 0, color: '#E57552' }}
                                    >
                                        <IconCard brand="eye" />
                                    </p>
                                </div>
                            </div>
                        );
                    };





                    const options = currentUserListings
                        .filter(item => {
                            const hasRoles = item?.attributes?.publicData?.roles?.length > 0;
                            if (!hasRoles) return false;
                            const companyRoles = item?.attributes?.publicData?.roles.map(r => r?.label) || [];

                            const matchFound = companyRoles.some(companyRole => {
                                const companyGroup = findRoleGroup(companyRole);
                                return studentLabels.some(studentRole => {
                                    const studentGroup = findRoleGroup(studentRole);
                                    return companyGroup && studentGroup && companyGroup === studentGroup;
                                });
                            });
                            return matchFound;
                        })
                        .map(item => ({
                            value: item?.id?.uuid,
                            label: item?.attributes?.title,
                        }));

                    return (
                        <Form>
                            <div>
                                {showModal == "Notes"
                                    ? <div className={css.thoughtBox}>
                                        <H4 as="h2" className={css.sectionTitle}>
                                            <div className={css.headingLine}>
                                                <FormattedMessage id="ChatForm.thoughtHeading" />
                                            </div>
                                            <div className={css.headingLine}>
                                                <FormattedMessage id='ChatForm.thoughtHeadingSecond' />
                                            </div>
                                        </H4>
                                        <FieldTextInput
                                            type="textarea"
                                            className={css.textareaBox}
                                            id="thoughts"
                                            name="thoughts"
                                            placeholder={intl.formatMessage({ id: "ChatForm.thoughtsPlaceholder" })}
                                        />
                                        {values.type == 'SEND'
                                            ? <FieldTextInput
                                                type="email"
                                                id={'email'}
                                                name="email"
                                                autoComplete="email"
                                                label={emailLabel}
                                                className={css.textareaBox}
                                                placeholder={emailPlaceholder}
                                                validate={validators.composeValidators(emailRequired, emailValid)}
                                            />
                                            : null}
                                        <div className={css.bottomButton}>
                                            <PrimaryButton
                                                type='button'
                                                inProgress={inProgress == 'SAVE'}
                                                onClick={() => {
                                                    form.change('showModal', showModal);
                                                    form.change('type', 'SAVE');
                                                    handleSubmit(values);
                                                }}
                                            >
                                                <FormattedMessage id="ChatForm.savethoughtNotes" />
                                            </PrimaryButton>
                                            <SecondaryButton
                                                type='button'
                                                inProgress={inProgress == 'SEND'}
                                                onClick={() => {
                                                    if (values.type == 'SEND') {
                                                        handleSubmit(values);
                                                    } else {
                                                        form.change('showModal', showModal);
                                                        form.change('type', 'SEND');
                                                    }
                                                }}
                                            >
                                                <FormattedMessage id="ChatForm.sendNotesButton" />
                                            </SecondaryButton>
                                        </div>
                                    </div>
                                    : <div className={css.chatWrapper}>
                                        {matchingLabels && matchingLabels?.length > 0 ? <>
                                            <div className={css.sectionContainer}>
                                                <H4 as="h2" className={css.sectionTitle}>
                                                    <img src={requestformLogo} />
                                                    <FormattedMessage id="ChatForm.Heading" />{showPortfolio ? name : initials}
                                                </H4>
                                                <p className={css.subCenterTitle}><FormattedMessage id="ChatForm.Subheading" /></p>

                                                <div className={css.nameContainer}>
                                                    {currentUserListings && currentUserListings.length
                                                        ? <Select
                                                            id={`role`}
                                                            className={css.quantityField}
                                                            name={"role"}
                                                            validate={validators.required(intl.formatMessage({ id: 'ChatForm.roleRequired' }))}
                                                            options={options}
                                                            isSearchable={false}
                                                            placeholder="Select a role"
                                                            components={{ Option: CustomOption }}
                                                            styles={{
                                                                control: (base, state) => ({
                                                                    ...base,
                                                                    height: '52px',
                                                                    minHeight: '52px',
                                                                    border: '1px solid #E6E6E6',
                                                                    borderRadius: '100px',
                                                                    boxShadow: '1px 1px 2px 1px rgba(0, 0, 0, 0.25) inset',
                                                                    fontFamily: "'Source Serif 4', serif",
                                                                    fontSize: '18px',
                                                                }),
                                                                valueContainer: (base) => ({
                                                                    ...base,
                                                                    padding: '0 16px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                }),
                                                                placeholder: (base) => ({
                                                                    ...base,
                                                                    margin: 0,
                                                                }),
                                                                singleValue: (base) => ({
                                                                    ...base,
                                                                    margin: 0,
                                                                }),
                                                            }}
                                                            onChange={(selectedOption) => {
                                                                const matchedBooking = portfolioId?.find(
                                                                    item => item?.companyId === selectedOption?.value
                                                                );

                                                                if (matchedBooking) {
                                                                    setAlreadyBooked({
                                                                        booked: true,
                                                                        transactionId: matchedBooking?.transactionId
                                                                    });
                                                                } else {
                                                                    setAlreadyBooked({
                                                                        booked: false,
                                                                        transactionId: {}
                                                                    });
                                                                    form.change('role', selectedOption?.value);
                                                                }
                                                            }}
                                                        />
                                                        : null}

                                                    <div className={css.roleRequest}>
                                                        <NamedLink name="NewCompanyListingPage">
                                                            <FormattedMessage id="ChatForm.createNewJobListing" />
                                                        </NamedLink>
                                                    </div>

                                                    {alreadyBooked?.booked && (
                                                        <div className={css.nameContainer}>
                                                            <div className={css.rowInput2}>
                                                                <h5 className={css.noMatch}>
                                                                    Hey, Good News! You've already connected with this Fractional Pro
                                                                </h5>

                                                                {alreadyBooked.transactionId && (
                                                                    <div
                                                                        className={css.roleRequest}
                                                                        onClick={() =>
                                                                            history.push(
                                                                                createResourceLocatorString(
                                                                                    'OrderDetailsPage',
                                                                                    routeConfiguration,
                                                                                    {
                                                                                        id: alreadyBooked?.transactionId,
                                                                                    }
                                                                                )
                                                                            )
                                                                        }
                                                                    >
                                                                        <h5 style={{ cursor: 'pointer' }}>Have a Chat Again</h5>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {!alreadyBooked?.booked ? (
                                                        <FieldSelect
                                                            id={`hoursPerWeek`}
                                                            className={css.hoursInputWrapper}
                                                            name={"hoursPerWeek"}
                                                            label={boardMember ? "Hours per month" : "Hours per week"}
                                                            validate={validators.required(intl.formatMessage({ id: 'ChatForm.hoursPerWeekRequired' }))}
                                                        >
                                                            <option disabled value="">
                                                                {"Select hours"}
                                                            </option>
                                                            {availableWorkingHours.map((item, i) => (
                                                                <option key={item.label + '-' + i} value={item.value}>
                                                                    {item.label}
                                                                </option>
                                                            ))}
                                                        </FieldSelect>
                                                    ) : null}
                                                </div>

                                            </div>
                                            {!alreadyBooked?.booked ?
                                                <div className={css.lastSection}>
                                                    {/* <FieldTextInput
                                                        type="textarea"
                                                        className={css.textareaBox}
                                                        id={"bio"}
                                                        name={"bio"}
                                                        placeholder={intl.formatMessage({ id: "ChatForm.askAQuestion" }, { name: showPortfolio ? name : initials })}
                                                    /> */}
                                                </div>
                                                : null}
                                            {!alreadyBooked?.booked ?

                                                <PrimaryButton
                                                    className={css.submitButton}
                                                    type='button'
                                                    onClick={() => {
                                                        form.change('showModal', '');
                                                        form.change('type', '');
                                                        handleSubmit(values)
                                                    }}
                                                    inProgress={inProgress == 'SUBMIT'}
                                                    disabled={submitDisabled || (currentUserListings && !currentUserListings.length) || !values.role || insufficientTokens}
                                                >
                                                    <FormattedMessage id="ChatForm.requestConnection" />
                                                    {"- " + tokensToDeduct + (tokensToDeduct == 1 ? ' Token' : ' Tokens')}
                                                </PrimaryButton>
                                                : null}
                                            <br />
                                            {(currentUserListings && !currentUserListings.length)
                                                ? <div className={css.roleRequests} >
                                                    <FormattedMessage id="ChatForm.createNewRoleInfo" />
                                                </div>
                                                : null}
                                            {insufficientTokens
                                                ? <div className={css.roleRequests} >
                                                    <FormattedMessage id="ChatForm.insufficientTokens" />

                                                    <NamedLink name="PurchaseAcornsPage" className={css.profileLink}>
                                                        <FormattedMessage id="ChatForm.purchaseAcorns" />
                                                    </NamedLink>
                                                </div>
                                                : null}
                                            {/* {!firstConnectionRequest
                                                ? <div className={css.firstConnectionRequest} >
                                                    {!firstConnectionOnAfterDisable ? '* Your first connection is on us.' : firstConnectionOnAfterDisable ? "Your previous free connection request has been declined. So this connection is on us." : null}
                                                </div>
                                                : null} */}
                                        </> :
                                            <div className={css.sectionContainer}>
                                                <H4 as="h2" className={css.sectionTitle}>
                                                    <img src={requestformLogo} />
                                                    <FormattedMessage id="ChatForm.Heading" />{showPortfolio ? name : initials}
                                                </H4>
                                                <p className={css.subCenterTitle}><FormattedMessage id="ChatForm.Subheading" /></p>
                                                <h5 className={css.noMatch}>No matching role found. Please create a new job listing with the same role as the{' '}
                                                    <span className={css.studentLabel}>
                                                        {studentLabels ? studentLabels : 'student'}
                                                    </span>
                                                    {' '}to proceed. </h5>
                                                <div className={css.roleRequest}>
                                                    <NamedLink name="NewCompanyListingPage">
                                                        <FormattedMessage id="ChatForm.createNewJobListing" />
                                                    </NamedLink>
                                                </div>
                                            </div>
                                        }

                                    </div>}
                            </div>
                        </Form>
                    );
                }
                }
            />
        );
    }
}

ChatFormComponent.defaultProps = {
    rootClassName: null,
    className: null,
    uploadImageError: null,
    updateProfileError: null,
    updateProfileReady: false,
};

ChatFormComponent.propTypes = {
    rootClassName: string,
    className: string,

    // from injectIntl
    intl: intlShape.isRequired,
};

const ChatForm = compose(injectIntl)(ChatFormComponent);

ChatForm.displayName = 'ChatForm';

export default ChatForm;
